// cart-lines.js - render items + qty controls, unified via PBCart
const TRASH_SVG = `
<svg width="16" height="16" viewBox="0 0 24 24" fill="none"
     xmlns="http://www.w3.org/2000/svg" stroke="currentColor" stroke-width="1.8"
     stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
  <path d="M3 6h18" />
  <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
  <path d="M19 6l-1.2 13a2 2 0 0 1-2 1.8H8.2a2 2 0 0 1-2-1.8L5 6" />
  <path d="M10 10v7M14 10v7" />
</svg>`;

(function () {
  const drawer = document.getElementById('UnifiedCartDrawer');
  if (!drawer) return;

  const list = document.getElementById('CartLineItems');
  const subtotalEl = document.getElementById('CartSubtotal');

  function log(...a) {
    try {
      console.log('[UCD][lines]', ...a);
    } catch (e) {}
  }

  function formatEUR(cents) {
    const v = Math.max(0, Number(cents) || 0) / 100;

    try {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR'
      }).format(v);
    } catch {
      return '€' + v.toFixed(2).replace('.', ',');
    }
  }

  const bundleOpenByKey = Object.create(null);
  const USE_VISUAL_PICK_MIX_DISCOUNT = true;

  function decodeHtml(value) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  }

  function escapeAttr(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function encodeJsonAttr(value) {
    try {
      return encodeURIComponent(JSON.stringify(value || []));
    } catch {
      return encodeURIComponent('[]');
    }
  }

  function decodeJsonAttr(value) {
    try {
      return JSON.parse(decodeURIComponent(value || '%5B%5D'));
    } catch {
      return [];
    }
  }

  function parseDiscountPercent(value) {
    const n = Number(String(value || '').replace('%', '').trim());
    return Number.isFinite(n) ? n : 0;
  }

  function getPickMixEditUrl(bundleId) {
  try {
    if (bundleId) {
      const byId = localStorage.getItem(`pb_pick_mix_edit_url_${bundleId}`);
      if (byId) return byId;
    }

    const latest = localStorage.getItem('pb_pick_mix_edit_url_latest');
    if (latest) return latest;

    if (window.PB_PICK_MIX_DEFAULT_EDIT_URL) {
      return window.PB_PICK_MIX_DEFAULT_EDIT_URL;
    }

    return '/pages/pick-mix?pm_edit=1';
  } catch {
    return window.PB_PICK_MIX_DEFAULT_EDIT_URL || '/pages/pick-mix?pm_edit=1';
  }
}

  function getPickMixDisplayItems(bundleId) {
    if (bundleId && window.PB_PICK_MIX_DISPLAY_BY_ID?.[bundleId]?.length) {
      return window.PB_PICK_MIX_DISPLAY_BY_ID[bundleId];
    }

    if (window.PB_LAST_PICK_MIX_DISPLAY?.length) {
      return window.PB_LAST_PICK_MIX_DISPLAY;
    }

    try {
      if (bundleId) {
        const byId = JSON.parse(localStorage.getItem(`pb_pick_mix_display_${bundleId}`) || '[]');
        if (Array.isArray(byId) && byId.length) return byId;
      }

      const latest = JSON.parse(localStorage.getItem('pb_pick_mix_display_latest') || '[]');
      return Array.isArray(latest) ? latest : [];
    } catch {
      return [];
    }
  }

  function isPickMixLine(item) {
    if (!item || !item.properties) return false;

    // If Cart Transform already made this into one Shopify bundle line,
    // do not group it again inside the drawer.
    if (item.isPickMixTransformedLine || item.isBundle) return false;

    const props = item.properties;

    return (
      (props._pick_mix === 'true' && props._pick_mix_id) ||
      (props.pb_pick_mix === 'true' && props.pb_pick_mix_id)
    );
  }

  function groupPickMixLines(items) {
    const result = [];
    const groups = Object.create(null);

    items.forEach((item) => {
      if (!isPickMixLine(item)) {
        result.push(item);
        return;
      }

      const groupId = item.properties._pick_mix_id || item.properties.pb_pick_mix_id;
      const title = decodeHtml(
        item.properties._pick_mix_title ||
        item.properties.pb_pick_mix_title ||
        'Pick & Mix'
      );

      if (!groups[groupId]) {
        groups[groupId] = {
          key: `pickmix_${groupId}`,
          id: `pickmix_${groupId}`,
          product_title: title,
          handle: '',
          variant_title: '',
          quantity: 1,
          url: '#',
          image: item.image,
          properties: {
            _pick_mix_parent: 'true',
            _pick_mix_id: groupId,
            _pick_mix_title: title,
            _pick_mix_discount:
              item.properties._pick_mix_discount ||
              item.properties.pb_pick_mix_discount ||
              '0%'
          },
          isBundle: false,
          bundleNodes: [],
          isPickMixGroup: true,
          pickMixItems: [],
          pickMixLineIds: []
        };

        result.push(groups[groupId]);
      }

      groups[groupId].pickMixItems.push(item);
      groups[groupId].pickMixLineIds.push(item.key);
    });

    Object.values(groups).forEach((group) => {
      const children = group.pickMixItems || [];

      const originalTotal = children.reduce((sum, item) => {
        return sum + (Number(item.original_line_price) || 0);
      }, 0);

      const realFinalTotal = children.reduce((sum, item) => {
        return sum + (Number(item.final_line_price) || 0);
      }, 0);

      const totalQty = children.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0);
      }, 0);

      const discountPercent = parseDiscountPercent(group.properties._pick_mix_discount);

      const visualFinalTotal = discountPercent > 0
        ? Math.round(originalTotal * (100 - discountPercent) / 100)
        : realFinalTotal;

      group.quantity = totalQty;
      group.pickMixCount = totalQty;
      group.original_line_price = originalTotal;
      group.final_line_price = USE_VISUAL_PICK_MIX_DISCOUNT ? visualFinalTotal : realFinalTotal;

      if (!group.image && children[0]?.image) {
        group.image = children[0].image;
      }
    });

    return result;
  }

  async function removePickMixGroup(lineIds) {
    const ids = [...new Set((Array.isArray(lineIds) ? lineIds : []).filter(Boolean))];

    if (!ids.length) return fetchCart();

    if (window.PBCart && typeof PBCart.removeLines === 'function') {
      const cart = await PBCart.removeLines(ids);
      return normalizeCart(cart);
    }

    console.warn('[UCD][lines] PBCart.removeLines missing. Falling back to one-by-one remove.');

    let cart = null;

    for (const lineId of ids) {
      cart = await PBCart.removeLine(lineId);
    }

    if (cart) return normalizeCart(cart);
    return fetchCart();
  }

  function normalizeCart(gqlCart) {
    const rawItems = (gqlCart.lines?.edges || []).map((e) => {
      const n = e.node;
      const merch = n.merchandise;
      const product = merch?.product || {};
      const attrs = Object.fromEntries((n.attributes || []).map((a) => [a.key, a.value]));

      const productTitleLower = String(product.title || '').trim().toLowerCase();

      const isPickMixTransformedLine =
        (
          (attrs._pick_mix === 'true' && attrs._pick_mix_id) ||
          (attrs.pb_pick_mix === 'true' && attrs.pb_pick_mix_id) ||
          productTitleLower === 'pick & mix' ||
          productTitleLower === 'pick & mix bundle' ||
          productTitleLower.includes('pick & mix')
        );

      const pickMixBundleId =
        attrs._pick_mix_id ||
        attrs.pb_pick_mix_id ||
        '';

      const pickMixDisplayItems = isPickMixTransformedLine
        ? getPickMixDisplayItems(pickMixBundleId)
        : [];

      const isBundle = merch?.requiresComponents === true;
      const bundleNodes = merch?.components?.nodes || [];

      const before = Math.round(parseFloat(n.cost?.subtotalAmount?.amount || 0) * 100);

      const discount = Array.isArray(n.discountAllocations)
        ? n.discountAllocations.reduce((sum, da) => {
            return sum + Math.round(parseFloat(da.discountedAmount?.amount || 0) * 100);
          }, 0)
        : 0;

      const after = Math.max(0, before - discount);

      return {
        key: n.id,
        id: merch?.id,

        product_title: isPickMixTransformedLine
          ? decodeHtml(attrs._pick_mix_title || attrs.pb_pick_mix_title || 'Pick & Mix')
          : product.title,

        handle: isPickMixTransformedLine ? '' : product.handle,
        variant_title: merch?.title || '',
        quantity: n.quantity,

        final_line_price: after,
        original_line_price: before,

        url: isPickMixTransformedLine ? '#' : `/products/${product.handle || ''}`,
        image: merch?.image?.url || pickMixDisplayItems[0]?.image || '',
        properties: attrs,

        isBundle,
      bundleNodes,
      isPickMixTransformedLine,
      pickMixBundleId,
      editUrl: isPickMixTransformedLine ? getPickMixEditUrl(pickMixBundleId) : '',
      pickMixItems: pickMixDisplayItems,
      pickMixCount: pickMixDisplayItems.reduce((sum, item) => {
        return sum + (Number(item.quantity) || 0);
      }, 0)
      };
    });

    const items = groupPickMixLines(rawItems);

    const original_total_price = items.reduce((s, it) => {
      return s + (Number(it.original_line_price) || 0);
    }, 0);

    const visual_total_price = items.reduce((s, it) => {
      return s + (Number(it.final_line_price) || 0);
    }, 0);

    return {
      items,
      total_price: USE_VISUAL_PICK_MIX_DISCOUNT
        ? visual_total_price
        : Math.round(parseFloat(gqlCart.cost?.subtotalAmount?.amount || 0) * 100),
      original_total_price
    };
  }

  function fetchCart() {
    return PBCart.current().then(normalizeCart);
  }

  function changeLine(lineId, quantity) {
    if (quantity <= 0) return PBCart.removeLine(lineId).then(normalizeCart);
    return PBCart.updateLine(lineId, quantity).then(normalizeCart);
  }

  function withWidthParam(src, w) {
    if (!src) return '';
    const join = src.includes('?') ? '&' : '?';
    return `${src}${join}width=${w}`;
  }

  function isMeaningfulVariantTitle(t) {
    const s = String(t || '').trim();
    if (!s) return false;
    if (s.toLowerCase() === 'default title') return false;
    return true;
  }

  function bundleComponentsHTML(lineKey, bundleNodes, parentQty) {
    const nodes = Array.isArray(bundleNodes) ? bundleNodes : [];
    if (!nodes.length) return '';

    const count = nodes.length;
    const isOpen = bundleOpenByKey[lineKey] === true;

    const rows = nodes.map((c) => {
      const pv = c?.productVariant || {};
      const qtyEach = Number(c?.quantity || 1);
      const qty = qtyEach * Number(parentQty || 1);

      const productTitle = pv?.product?.title || 'Item';
      const variantTitle = pv?.title || '';
      const showVariant = isMeaningfulVariantTitle(variantTitle);

      const handle = pv?.product?.handle;
      const href = handle ? `/products/${handle}` : '#';

      const imgSrc = pv?.image?.url ? withWidthParam(pv.image.url, 96) : '';
      const imgAlt = pv?.image?.altText || productTitle;

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${qty} ×</div>

          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${imgSrc ? `<img class="ucd-bundle-img" src="${imgSrc}" alt="${escapeAttr(imgAlt)}">` : ''}
          </a>

          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${productTitle}</div>
              ${showVariant ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <div class="ucd-bundle" data-linekey="${lineKey}">
        <button type="button"
          class="ucd-bundle-toggle"
          aria-expanded="${isOpen ? 'true' : 'false'}"
          data-count="${count}">
          <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
          <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
        </button>

        <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
          ${rows}
        </div>
      </div>
    `;
  }

  function pickMixLineHTML(item) {
    const img = item.image ? withWidthParam(item.image, 240) : '';
    const title = item.product_title || 'Pick & Mix';
    const discount = item.properties?._pick_mix_discount || '';
    const discountAmount = Math.max(
      0,
      Number(item.original_line_price || 0) - Number(item.final_line_price || 0)
    );

    const children = item.pickMixItems || [];
    const count = Number(item.pickMixCount || 0);
    const isOpen = bundleOpenByKey[item.key] !== false;
    const lineIdsData = encodeJsonAttr(item.pickMixLineIds || []);

    const rows = children.map((child) => {
      const childImg = child.image ? withWidthParam(child.image, 96) : '';
      const productTitle = child.product_title || 'Item';
      const variantTitle = child.variant_title || '';
      const showVariant = isMeaningfulVariantTitle(variantTitle);
      const href = child.url || '#';

      return `
        <div class="ucd-bundle-row">
          <div class="ucd-bundle-qty">${child.quantity}×</div>

          <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
            ${childImg ? `<img class="ucd-bundle-img" src="${childImg}" alt="${escapeAttr(productTitle)}">` : ''}
          </a>

          <a class="ucd-bundle-link" href="${href}">
            <div class="ucd-bundle-text">
              <div class="ucd-bundle-product">${productTitle}</div>
              ${showVariant ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
            </div>
          </a>
        </div>
      `;
    }).join('');

    return `
      <li class="ucd-line ucd-line--pickmix"
          data-key="${item.key}"
          data-pick-mix-group="true"
          data-pick-mix-line-ids="${lineIdsData}">
        <div class="ucd-media">
          ${
            img
              ? `<img src="${img}" alt="${escapeAttr(title)}">`
              : `<div style="width:100%;height:100%;background:#f5d7d7;border-radius:10px;"></div>`
          }
        </div>

        <div class="ucd-info">
          <a role="heading" aria-level="5" href="#" class="ucd-title">
            ${title.toUpperCase()}
          </a>

          ${discount ? `<div class="ucd-bundle-variant">${discount} korting</div>` : ``}
          ${discountAmount > 0 ? `<div class="ucd-bundle-variant">Korting: -${formatEUR(discountAmount)}</div>` : ``}

          <button type="button"
            class="ucd-bundle-toggle"
            aria-expanded="${isOpen ? 'true' : 'false'}"
            data-count="${count}">
            <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
            <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
          </button>
        </div>

        <div class="ucd-price">
  <button type="button" aria-label="Remove ${escapeAttr(title)}" class="ucd-remove1">
    ${TRASH_SVG}
  </button>


          <div>
            ${
              Number(item.original_line_price) > Number(item.final_line_price)
                ? `<span class="ucd-money ucd-money--compare">${formatEUR(item.original_line_price)}</span>
                   <span class="ucd-money ucd-money--sale">${formatEUR(item.final_line_price)}</span>`
                : `<span class="ucd-money">${formatEUR(item.final_line_price)}</span>`
            }
          </div>
        </div>

        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      </li>
    `;
  }

  function lineItemHTML(item) {
    if (item.isPickMixGroup) {
      return pickMixLineHTML(item);
    }

    const img = item.image ? withWidthParam(item.image, 240) : '';
    const href = item.url || item.handle ? (`/products/${item.handle || ''}`) : '#';
    const isGift = item.properties && item.properties._auto_gift === 'true';
    //const hideQtyControls = item.isPickMixTransformedLine === true;
    const isPickMixCartLine =
  item.isPickMixTransformedLine === true ||
  item.isPickMixGroup === true ||
  item.properties?._pick_mix === 'true' ||
  item.properties?.pb_pick_mix === 'true' ||
  String(item.product_title || '').toLowerCase().includes('pick & mix');

const hideQtyControls = isPickMixCartLine;
    const editUrl = item.isPickMixTransformedLine
  ? (item.editUrl || getPickMixEditUrl(item.pickMixBundleId))
  : '';

    const pickMixDiscount =
      item.properties?._pick_mix_discount ||
      item.properties?.pb_pick_mix_discount ||
      '';

    let bundleToggleHtml = '';
    let bundleItemsHtml = '';

    if (item.isPickMixTransformedLine && item.pickMixItems?.length) {
      const count = item.pickMixCount || item.pickMixItems.length;
      const isOpen = bundleOpenByKey[item.key] !== false;

      const rows = item.pickMixItems.map((child) => {
        const childImg = child.image ? withWidthParam(child.image, 96) : '';
        const productTitle = child.title || 'Item';
        const variantTitle = child.subtitle || '';
        const href = child.url || '#';

        return `
          <div class="ucd-bundle-row">
            <div class="ucd-bundle-qty">${child.quantity}×</div>

            <a class="ucd-bundle-thumb" href="${href}" aria-label="${escapeAttr(productTitle)}">
              ${childImg ? `<img class="ucd-bundle-img" src="${childImg}" alt="${escapeAttr(productTitle)}">` : ''}
            </a>

            <a class="ucd-bundle-link" href="${href}">
              <div class="ucd-bundle-text">
                <div class="ucd-bundle-product">${productTitle}</div>
                ${variantTitle ? `<div class="ucd-bundle-variant">${variantTitle}</div>` : ``}
              </div>
            </a>
          </div>
        `;
      }).join('');

      bundleToggleHtml = `
        <button type="button"
          class="ucd-bundle-toggle"
          aria-expanded="${isOpen ? 'true' : 'false'}"
          data-count="${count}">
          <span class="ucd-bundle-toggle__label">${isOpen ? `Hide ${count} items` : `Show ${count} items`}</span>
          <span class="ucd-bundle-toggle__chev" aria-hidden="true">${isOpen ? '▴' : '▾'}</span>
        </button>
      `;

      bundleItemsHtml = `
        <div class="ucd-bundle" data-linekey="${item.key}">
          <div class="ucd-bundle-items" style="display:${isOpen ? 'block' : 'none'};">
            ${rows}
          </div>
        </div>
      `;
    } else if (item.isBundle) {
      const bundleHTML = bundleComponentsHTML(item.key, item.bundleNodes, item.quantity);

      const temp = document.createElement('div');
      temp.innerHTML = bundleHTML;

      const bundle = temp.querySelector('.ucd-bundle');
      const toggle = bundle?.querySelector('.ucd-bundle-toggle');
      const items = bundle?.querySelector('.ucd-bundle-items');

      if (toggle) bundleToggleHtml = toggle.outerHTML;
      if (items) {
        bundleItemsHtml = `
          <div class="ucd-bundle" data-linekey="${item.key}">
            ${items.outerHTML}
          </div>
        `;
      }
    }

    return `
      <li class="ucd-line ${item.isPickMixTransformedLine ? 'ucd-line--pickmix-transformed' : ''}" data-key="${item.key}">
        <div class="ucd-media">
          ${
            img
              ? `<a href="${href}" aria-label="View details for ${escapeAttr(item.product_title)}">
                  <img src="${img}" alt="${escapeAttr(item.product_title)}">
                </a>`
              : ''
          }
        </div>

        <div class="ucd-info">
          <a role="heading" aria-level="5" href="${href}" class="ucd-title">
            ${item.product_title}${isGift ? ' <span class="ucd-gift-tag">• Gift</span>' : ''}
          </a>

          ${item.isPickMixTransformedLine && pickMixDiscount ? `<div class="ucd-bundle-variant">${pickMixDiscount} korting</div>` : ''}

          ${hideQtyControls ? '' : `
            <div class="ucd-qty">
              <button aria-label="Decrease quantity of ${escapeAttr(item.product_title)}" type="button" class="ucd-qty-btn" data-act="dec">−</button>
              <span class="ucd-qty-label">
                <span class="sr-only">Quantity of ${item.product_title}</span>
                <span class="ucd-qty-num">${item.quantity}</span>
              </span>
              <button aria-label="Increase quantity of ${escapeAttr(item.product_title)}" type="button" class="ucd-qty-btn" data-act="inc">＋</button>
            </div>
          `}

          ${bundleToggleHtml}
        </div>

        <div class="ucd-price">
 
  <div class="ucd-line-actions">
    ${editUrl ? `
      <a href="${escapeAttr(editUrl)}" class="ucd-edit-pickmix" aria-label="Edit Pick & Mix">
        ✎
      </a>
    ` : ''}

    <button type="button" aria-label="Remove ${escapeAttr(item.product_title)}" class="ucd-remove1">
      ${TRASH_SVG}
    </button>
  </div>

          <div>
            ${
              Number(item.original_line_price) > Number(item.final_line_price)
                ? `<span class="ucd-money ucd-money--compare">${formatEUR(item.original_line_price)}</span>
                   <span class="ucd-money ucd-money--sale">${formatEUR(item.final_line_price)}</span>`
                : `<span class="ucd-money">${formatEUR(item.final_line_price)}</span>`
            }
          </div>
        </div>

        ${bundleItemsHtml}
      </li>
    `;
  }

  function bindEvents() {
    list.querySelectorAll('.ucd-line').forEach((li) => {
      const key = li.dataset.key;
      const isPickMixGroup = li.dataset.pickMixGroup === 'true';

      if (isPickMixGroup) {
        li.querySelector('.ucd-remove1')?.addEventListener('click', () => {
          const lineIds = decodeJsonAttr(li.dataset.pickMixLineIds);

          lineSetLoading(li, true);

          removePickMixGroup(lineIds)
            .then((cart) => render(cart))
            .finally(() => lineSetLoading(li, false));
        });

        return;
      }

      li.querySelectorAll('.ucd-qty-btn').forEach((btn) => {
        const act = btn.dataset.act;

        btn.addEventListener('click', () => {
          const numEl = li.querySelector('.ucd-qty-num');
          const qtyNow = Number(numEl?.textContent || 1);
          const next = act === 'inc' ? qtyNow + 1 : Math.max(0, qtyNow - 1);
          if (next === qtyNow) return;

          numEl.textContent = String(next);
          lineSetLoading(li, true);

          changeLine(key, next)
            .then((cart) => render(cart))
            .catch(() => {
              numEl.textContent = String(qtyNow);
            })
            .finally(() => lineSetLoading(li, false));
        });
      });

      li.querySelector('.ucd-remove1')?.addEventListener('click', () => {
        lineSetLoading(li, true);
        changeLine(key, 0)
          .then((cart) => render(cart))
          .finally(() => lineSetLoading(li, false));
      });
    });
  }

  let bundleToggleBound = false;

  function bindBundleToggles() {
    if (bundleToggleBound) return;
    if (!list) return;

    bundleToggleBound = true;

    list.addEventListener('click', (e) => {
      const btn = e.target?.closest?.('.ucd-bundle-toggle');
      if (!btn) return;

      const line = btn.closest('.ucd-line');
      if (!line) return;

      const bundleWrap = line.querySelector('.ucd-bundle');
      const panel = bundleWrap?.querySelector('.ucd-bundle-items');
      const lineKey = bundleWrap?.dataset?.linekey;

      if (!panel || !lineKey) return;

      const expanded = btn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;

      btn.setAttribute('aria-expanded', next ? 'true' : 'false');
      panel.style.display = next ? 'block' : 'none';

      bundleOpenByKey[lineKey] = next;

      const count = Number(btn.dataset.count || 0);
      const label = btn.querySelector('.ucd-bundle-toggle__label');
      const chev = btn.querySelector('.ucd-bundle-toggle__chev');

      if (label) label.textContent = next ? `Hide ${count} items` : `Show ${count} items`;
      if (chev) chev.textContent = next ? '▴' : '▾';
    });
  }

  function ensureGiftsMount() {
    let mount = document.getElementById('CartFreeGifts');

    if (!mount && list?.parentElement) {
      mount = document.createElement('div');
      mount.id = 'CartFreeGifts';
      mount.className = 'ucd-gifts-card';
      list.parentElement.insertBefore(mount, list);
    }

    return mount;
  }

  function giftGalleryItemHTML(item) {
    const img = item.image ? withWidthParam(item.image, 160) : '';

    return `
      <div class="ucd-gift-thumb" data-key="${item.key}">
        <button class="ucd-gift-remove" aria-label="Remove ${escapeAttr(item.product_title)}" title="Remove">×</button>
        ${img ? `<img src="${img}" alt="${escapeAttr(item.product_title)}">` : ``}
      </div>
    `;
  }

  function giftPillHTML(item) {
    const title = item.product_title || 'Gift';
    return `<span class="gift-pill" data-key="${item.key}">${title}</span>`;
  }

  function renderGiftsBlock(gifts) {
    const mount = ensureGiftsMount();
    if (!mount) return;

    if (!gifts.length) {
      mount.innerHTML = '';
      return;
    }

    const gallery = gifts.map(giftGalleryItemHTML).join('');
    const pills = gifts.map(giftPillHTML).join('');

    mount.innerHTML = `
      <div class="ucd-gifts-heading">FREE GIFTS</div>
      <div class="ucd-gifts-gallery">${gallery}</div>
      <div class="ucd-gifts-list">${pills}</div>
    `;

    mount.querySelectorAll('.ucd-gift-remove').forEach((btn) => {
      const thumb = btn.closest('.ucd-gift-thumb');
      const key = thumb?.dataset.key;
      if (!key) return;

      btn.addEventListener('click', async () => {
        mount.classList.add('is-loading');

        try {
          const giftItem = gifts.find((g) => g.key === key);
          const variantGid = giftItem?.id || '';
          const numericVid = Number(variantGid.split('/').pop());

          await changeLine(key, 0);

          try {
            const store = JSON.parse(sessionStorage.getItem('ucd_suppressed_gift_variants') || '[]');

            if (Number.isFinite(numericVid) && !store.includes(numericVid)) {
              store.push(numericVid);
            }

            sessionStorage.setItem('ucd_suppressed_gift_variants', JSON.stringify(store));
          } catch (e) {}

          fetchCart().then(render);
        } finally {
          mount.classList.remove('is-loading');
        }
      });
    });
  }

  let lastSig = '';

  function signature(cart) {
    const itemsSig = (cart.items || [])
      .map((i) => {
        if (i.isPickMixGroup) {
          return `${i.key}:${i.pickMixCount}:${i.original_line_price}:${i.final_line_price}:pm`;
        }

        return `${i.key}:${i.quantity}:${i.original_line_price}:${i.final_line_price}:${i.isBundle ? 'b' : 'n'}:${i.isPickMixTransformedLine ? 'pmt' : ''}:${i.pickMixCount || 0}`;
      })
      .join('|');

    return `${itemsSig}@${cart.total_price}`;
  }

  function renderSubtotal(cart) {
    if (!subtotalEl) return;

    const before = Number(cart.original_total_price) || 0;
    const after = Number(cart.total_price) || 0;

    subtotalEl.innerHTML =
      before > after
        ? `<span class="ucd-money ucd-money--compare">${formatEUR(before)}</span>
           <span class="ucd-money ucd-money--sale">${formatEUR(after)}</span>`
        : `<span class="ucd-money">${formatEUR(after)}</span>`;
  }

  function render(cart) {
    if (!list) return;

    const sig = signature(cart);

    if (sig === lastSig) {
      renderSubtotal(cart);
      return;
    }

    lastSig = sig;

    const items = cart.items || [];

    if (!items.length) {
      renderGiftsBlock([]);

      list.innerHTML = `
        <div class="empty-cart-container">
          <div class="empty-cart-image">
            <img src="https://cdn.shopify.com/s/files/1/0276/8430/7018/files/empty_cart.png?v=1750336414" alt="Empty Cart Icon">
          </div>
          <div class="empty-cart-title">Je winkelwagen is leeg.</div>
          <a href="/collections/all" class="shop-button">Verder winkelen</a>
        </div>
      `;
    } else {
      const normal = [];
      const gifts = [];

      for (const it of items) {
        const isGift = it.properties && it.properties._auto_gift === 'true';
        (isGift ? gifts : normal).push(it);
      }

      renderGiftsBlock(gifts);
      list.innerHTML = normal.map(lineItemHTML).join('');
      bindEvents();
      bindBundleToggles();
    }

    renderSubtotal(cart);
  }

  let t;

  function schedule() {
    clearTimeout(t);

    t = setTimeout(() => {
      fetchCart()
        .then(render)
        .catch((err) => {
          log('fetch error', err);

          if (list) {
            list.innerHTML = `<li class="ucd-empty">Kan cart niet laden.</li>`;
          }
        });
    }, 120);
  }

  function lineSetLoading(li, on) {
    if (!li) return;

    li.classList.toggle('is-loading', !!on);

    let spin = li.querySelector('.ucd-line-spinner');

    if (!spin) {
      spin = document.createElement('span');
      spin.className = 'ucd-line-spinner ucd-spinner';
      spin.setAttribute('aria-hidden', 'true');
      li.appendChild(spin);
    }

    spin.style.display = on ? 'inline-block' : 'none';

    li.querySelectorAll('.ucd-qty-btn, .ucd-remove, .ucd-remove1').forEach((el) => {
      el.disabled = !!on;
      el.setAttribute('aria-disabled', on ? 'true' : 'false');
    });
  }

  function initOnce() {
    schedule();
  }

  document.addEventListener('DOMContentLoaded', initOnce);
  document.addEventListener('pb:cart:updated', (e) => render(normalizeCart(e.detail.cart)));
  document.addEventListener('cart:open', schedule);
})();